import { CatalogRecHeaderLicense } from '@aipb/gulliver/catalog/model';

import { Component, inject, Input } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'cat-header-license',
  templateUrl: './header-license.component.html',
  styleUrls: ['./header-license.component.scss'],
  standalone: true,
  imports: []
})
export class HeaderLicenseComponent {
  @Input() license: CatalogRecHeaderLicense;

  private transloco = inject(TranslocoService);

  getUrl() {
    const lang = this.transloco.getActiveLang();

    if (lang in this.license.url) {
      return this.license.url[lang];
    }

    return '';
  }
}
